// @ts-nocheck

import Map from "../../components/Map";
import React, { useState } from "react";

const App: React.FC = () => {
  const [origin, setOrigin] = useState<{ lat: number; lng: number } | null>(
    null
  );
  const [destination, setDestination] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [showMap, setShowMap] = useState<boolean>(false);

  const handleOriginChange = (event, coord) => {
    const value = parseFloat(event.target.value);
    console.log("Input value:", event.target.value); // Imprime el valor del input
    setOrigin((prevOrigin) => {
      if (prevOrigin) {
        return { ...prevOrigin, [coord]: value };
      }
      return { [coord]: value }; // Para el primer valor
    });
    console.log("Origin state:", origin); // Imprime el estado origin
  };

  const handleDestinationChange = (event, coord) => {
    const value = parseFloat(event.target.value);
    console.log("Input value:", event.target.value); // Imprime el valor del input
    setDestination((prevDestination) => {
      if (prevDestination) {
        return { ...prevDestination, [coord]: value };
      }
      return { [coord]: value }; // Para el primer valor
    });
    console.log("Destination state:", destination); // Imprime el estado destination
  };

  const handleShowMap = () => {
    if (origin && destination) {
      setShowMap(true);
      console.log("Origin and destination are valid:", origin, destination); // Verifica si las coordenadas son válidas
    } else {
      alert("Por favor, ingresa las coordenadas de origen y destino.");
      console.log("Origin or destination is null:", origin, destination); // Verifica si alguna coordenada es nula
    }
  };

  return (
    <div className="flex h-screen">
      <div className="flex flex-col items-center justify-center w-1/2 bg-gray-100">
        <div className="p-4 bg-white flex flex-col items-center justify-center ">
          <div className="w-full px-4">
            <label className="text-[12px] text-textTipic font-medium">
              Latitud Origen:
            </label>
            <input
              className="w-full border p-2 rounded text-textTipic text-[14px]"
              type="text"
              id="latitudOrigen"
              onChange={(e) => handleOriginChange(e, "lat")} // Llama a handleOriginChange
            />
          </div>
          <div className="w-full px-4 ">
            <label className="text-[12px] text-textTipic font-medium">
              Longitud Origen:
            </label>
            <input
              className="w-full border p-2 rounded text-textTipic text-[14px]"
              type="text"
              id="longitudOrigen"
              onChange={(e) => handleOriginChange(e, "lng")} // Llama a handleOriginChange
            />
          </div>

          <div className="w-full px-4 ">
            <label className="text-[12px] text-textTipic font-medium">
              Latitud Destino:
            </label>
            <input
              className="w-full border p-2 rounded text-textTipic text-[14px]"
              type="text"
              id="latitudDestino"
              onChange={(e) => handleDestinationChange(e, "lat")} // Llama a handleDestinationChange
            />
          </div>

          <div className="w-full px-4 ">
            <label className="text-[12px] text-textTipic font-medium">
              Longitud Destino:
            </label>
            <input
              className="w-full border p-2 rounded text-textTipic text-[14px]"
              type="text"
              id="longitudDestino"
              onChange={(e) => handleDestinationChange(e, "lng")} // Llama a handleDestinationChange
            />
          </div>

          <button
            className="bg-gray-400 text-white px-4 py-2 rounded-md w-[160px] mt-8"
            onClick={handleShowMap}
          >
            Mostrar Mapa
          </button>
        </div>
      </div>

      <div className="flex items-center justify-center w-1/2 ">
        {/* Renderiza el componente Map solo si showMap es true, origin y destination existen */}
        {showMap && origin && destination && (
          <Map origin={origin} destination={destination} />
        )}
      </div>
    </div>
  );
};

export default App;
